import Vue from 'vue';
import VueRouter from 'vue-router';
import HomeView from '../views/home/HomeView.vue';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('../views/login/index.vue')
  },
  {
    path: '/collect',
    name: 'collect',
    component: () => import('../views/home/collect.vue')
  },
  {
    path: '/refinedSift',
    name: 'refinedSift',
    component: () => import('../views/home/refinedSift.vue')
  },
  {
    path: '/caseinfo',
    name: 'caseinfo',
    component: () => import('../views/home/caseinfo.vue')
  },

  {
    path: '/user',
    name: 'user',
    redirect: '/user/upload',
    component: () => import('../views/user/index.vue'),
    children: [
      {
        path: '/user/upload',
        name: 'upload',
        component: () => import('../views/user/uploadFile.vue')
      },
      {
        path: '/user/myCase',
        name: 'case',
        component: () => import('../views/user/myCase.vue')
      },
      {
        path: '/user/myCopywriting',
        name: 'copywriting',
        component: () => import('../views/user/myCopywriting.vue')
      },
      {
        path: 'myCourse',
        name: 'myCourse',
        component: () => import('../views/user/myCourse')
      },
      {
        path: 'myCollections',
        name: 'myCollections',
        component: () => import('../views/user/myCollections')
      },
      {
        path: 'userMymsg',
        name: 'userMymsg',
        component: () => import('../views/user/userMymsg')
      }
    ]
  }
];
let originPush = VueRouter.prototype.push; // 备份原push方法

VueRouter.prototype.push = function (location, resolve, reject) {
  if (resolve && reject) {
    // 如果传了回调函数，直接使用
    originPush.call(this, location, resolve, reject);
  } else {
    // 如果没有传回调函数，手动添加
    originPush.call(
      this,
      location,
      () => {},
      () => {}
    );
  }
};

const router = new VueRouter({
  mode: 'history',
  routes
});

export default router;
